import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import crossIcon from '../../../../_metronic/assets/images/svg/data-room/cross-black-icon.svg'
import deleteIcon from '../../../../media/stakeholders/ic-delete.svg'
import { toast } from 'react-toastify'
import { useAuth } from '../../auth'
import { ToolTipUIForModal } from '../../widgets/components/UI/ToolTipUIForModal'
import { Spinner } from 'react-bootstrap'
import { DateTime } from 'luxon'
import { deleteSharedLink, getSharedLink, updateSharedLink } from '../core/_requests'
import { NoDataPage } from '../../resources/components/NoDataPage'
import OutsideClickHandler from 'react-outside-click-handler'
import { DeleteClassificationModal } from './RecordsClassifications/DeleteClassificationModal'

export const RecordShareDrawer = ({
    recordId,
    createRecordDrawer,
    setCreateRecordDrawer,
    setIsOpenShareDrawer
}: { recordId: string | undefined, createRecordDrawer: any, setCreateRecordDrawer: any, setIsOpenShareDrawer: any }) => {
    const { formatMessage } = useIntl()
    const { companyId } = useAuth()
    const [menuOpen, setMenuOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const [shareLinkApiData, setShareLinkApiData] = useState([])
    const [isDeleting, setIsDeleting] = useState<boolean>(false)
    const [recordSharedId, setRecordSharedId] = useState('')
    const [showShareLinkModal, setShareLinkShowModal] = useState(false)
    const handleCopyToClipboard = (link: string) => {
        navigator.clipboard
            .writeText(link)
            .then(() => {
                toast.success(formatMessage({ id: 'Link copied to clipboard' }))
            })
            .catch(() => {
                toast.error(formatMessage({ id: 'Failed to copy link to clipboard' }))
            })
    }

    function getTimeDifference(date: any) {
        const minutes = Math.abs(
            Math.floor(
                date &&
                DateTime.utc().diff(DateTime.fromISO(date), ['days', 'hours', 'minutes']).toObject()
                    .minutes
            )
        )

        const days = Math.abs(
            Math.floor(
                date &&
                DateTime.utc().diff(DateTime.fromISO(date), ['days', 'hours', 'minutes']).toObject().days
            )
        )

        const hours = Math.abs(
            Math.floor(
                date &&
                DateTime.utc().diff(DateTime.fromISO(date), ['days', 'hours', 'minutes']).toObject().hours
            )
        )
        if (days === 0 && hours === 0) {
            return `${minutes} ${formatMessage({ id: 'min ago' })}`
        }
        if (days === 0) {
            return `${hours} ${formatMessage({ id: 'hrs ago' })}`
        } else if (days === 7) {
            return `${formatMessage({ id: '1 week' })}`
        } else if (days < 7) {
            return `${days} ${formatMessage({ id: 'days ago' })}`
        } else {
            return DateTime.fromISO(date).toFormat('MMM dd')
        }
    }

    useEffect(() => {
        if (createRecordDrawer)
            getAllSharedLink()
    }, [createRecordDrawer]) // eslint-disable-line react-hooks/exhaustive-deps

    const getAllSharedLink = async () => {
        if (!recordId || !companyId) return
        setLoading(true)
        try {
            const { data: { success, data } } = await getSharedLink(companyId, recordId)
            if (success) {
                setShareLinkApiData(data)
            }
        }
        catch (error: any) {

        } finally {
            setLoading(false)
        }
    }
    const deleteChat = async () => {
        if (!recordSharedId) return
        setIsDeleting(true)
        try {
            if (companyId) {
                const { data: { success, errors } } = await deleteSharedLink(companyId, recordSharedId)
                if (success) {
                    toast.success(formatMessage({ id: 'Share link deleted successfully' }))
                } else {
                    toast.error(formatMessage({ id: errors[0].error }))
                }
            }
        } catch (err) {
            console.log(err)
        } finally {
            setIsDeleting(false)
            setShareLinkShowModal(false)
            getAllSharedLink()
        }
    }
    const handleToggleChange = (isChecked: boolean, recordShareId: string) => {
        // Optimistically update the UI state
        setShareLinkApiData((prevData: any) =>
            prevData.map((data: any) =>
                data.recordShareId === recordShareId ? { ...data, isActive: isChecked } : data
            )
        );

        // Call API to update the toggle state in the backend
        editShareLinkValue(isChecked, recordShareId);
    };
    const editShareLinkValue = async (newCheckedValue: boolean, id: any) => {
        if (!id || !companyId || !recordId) return
        try {
            const { data: { success } } = await updateSharedLink(companyId, id, newCheckedValue)
            if (success) {
                toast.success("Share Link updated successfully");
            } else {
                throw new Error("Something went wrong while updating the share link.");
            }
        } catch (err) {
            console.log(err)
        } finally {
            const { data: { success, data } } = await getSharedLink(companyId, recordId)
            if (success) {
                setShareLinkApiData(data)
            }
        }
    }
    const handleOpenModal = () => {
        setShareLinkShowModal(true)
        setMenuOpen(false)
    }

    return (
        <div
            id='kt_share'
            className={createRecordDrawer ? 'bg-body drawer drawer-end drawer-on' : 'bg-body drawer drawer-end'}
            data-kt-drawer='true'
            data-kt-drawer-name='activities'
            data-kt-drawer-activate='true'
            data-kt-drawer-overlay='true'
            data-kt-drawer-width="{default:'300px', 'md': '735px'}"
            data-kt-drawer-direction='end'
            data-kt-drawer-toggle='#kt_share_toggle'
            data-kt-drawer-close='#kt_share_close'
        >
            <div className='share-drawer-wrapper card shadow-none rounded-0 w-100'>
                <div
                    className='drawer-header d-flex flex-row align-items-center justify-content-between flex-wrap  '
                    id='kt_share_header'
                >
                    <div className='d-flex flex-row align-items-center mb-3 mb-md-0 w-md-auto w-100'>
                        <button
                            type='button'
                            className='btn p-0 btn-active-light-primary me-4 '
                            onClick={() => setCreateRecordDrawer(false)}
                        >
                            <img src={crossIcon} alt=''></img>
                        </button>
                        <div className='d-flex flex-row  justify-content-between justify-content-md-start justify-content-md-between flex-grow-1 flex-md-grow-0'>
                            <h3 className='drawer-head-title  mb-0 me-4 text-dark'>

                                {formatMessage({ id: 'Share this File' })}
                            </h3>

                            <div style={{ marginTop: '8px' }}>
                                <ToolTipUIForModal
                                    tooltipText={formatMessage({
                                        id: 'Generate a shareable links to this file. Use the link to share it with others.',
                                    })}
                                />
                            </div>
                        </div>
                    </div>

                    <button
                        onClick={() => {
                            setIsOpenShareDrawer(true)
                            setCreateRecordDrawer(false)
                        }}
                        className='btn bg-primary font-size-13 flex-grow-1 flex-md-grow-0 text-white font-weight-400 height-36 d-flex align-items-center justify-content-center custom-button-property'
                    >
                        {formatMessage({ id: 'Create Link' })}
                    </button>
                </div>

                <div className='share-drawer-body px-5 py-4 p-md-7 position-relative' id='kt_share_body'>
                    <div
                        id='kt_share_scroll'
                        className='w-100 d-flex flex-column align-items-center mb-5 mt-2 activity-container-n overflow-visible'
                    >
                        <div className='d-flex flex-column flex-md-row w-100'>
                            <>
                                {loading ? (
                                    <Spinner />
                                ) : shareLinkApiData && shareLinkApiData.length === 0 ? (
                                    <NoDataPage />
                                ) : (
                                    <table className='d-flex flex-column gap-5'>
                                        <thead>
                                            <tr className=' border-bottom'>
                                                <th className='title w-200px'>{formatMessage({ id: 'Account' })}</th>
                                                <th className='link w-325px'>{formatMessage({ id: 'Link' })}</th>
                                                <th className='w-150px'>
                                                    <div className='share-flex-wrapper action flex-grow-1 flex-md-grow-0 title ms-5'>
                                                        {formatMessage({ id: 'Actions' })}
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                shareLinkApiData.map((data: any) => {
                                                    return (
                                                        <tr>
                                                            <td className='share-flex-wrapper account flex-grow-1 flex-md-grow-0 w-200px'>
                                                                <div className='account-box d-flex flex-row flex-md-column align-item-center align-items-md-start'>
                                                                    <p className='text-dark m-0 font-size-13'> {data.account}</p>
                                                                    <span className='text-dark font-size-10'>
                                                                        {`${formatMessage({ id: 'updated ' })} ${getTimeDifference(data.updatedAt)}`}
                                                                    </span>
                                                                </div>
                                                            </td>

                                                            <td className='share-flex-wrapper link flex-grow-1 '>
                                                                <div className='link-box mb-2'>
                                                                    <button className='btn btn-light d-flex flex-row align-items-center button_eclipse h-40px'>
                                                                        <span className='span_eclipse '>
                                                                            <span className='text-dark'>{`${window.location.origin}/public/records-classifications/files-details/${data.recordShareId}`}</span>
                                                                        </span>
                                                                    </button>
                                                                    <div
                                                                        className='copy-to-clipboard-wrapper bg-white w-100 h-40px'
                                                                        onClick={() =>
                                                                            handleCopyToClipboard(
                                                                                `${window.location.origin}/public/records-classifications/files-details/${data.recordShareId}`
                                                                            )
                                                                        }
                                                                    >
                                                                        {formatMessage({ id: 'Copy to Clipboard' })}
                                                                    </div>
                                                                </div>
                                                            </td>

                                                            <td className='share-flex-wrapper action flex-grow-1 flex-md-grow-0 '>
                                                                <div className='action-box d-flex flex-row align-items-center justify-content-between justify-content-md-evenly'>
                                                                    <label className='toggle' htmlFor={`${data.recordShareId}`}>
                                                                        <input
                                                                            className='toggle__input'
                                                                            name='toggle-input'
                                                                            type='checkbox'
                                                                            id={`${data.recordShareId}`}
                                                                            checked={data.isActive}
                                                                            onChange={(e: any) => handleToggleChange(e.target.checked, data.recordShareId)}
                                                                        />
                                                                        <div className='toggle__fill'></div>
                                                                    </label>

                                                                </div>
                                                            </td>

                                                            <td className='Action'>
                                                                <div className=' card-option-wrapper'>
                                                                    <OutsideClickHandler onOutsideClick={() => setMenuOpen(false)}>
                                                                        <button
                                                                            type='button'
                                                                            className='btn btn-sm card-option btn-icon btn-color-primary btn-active-light-primary'
                                                                            onClick={() => {
                                                                                setMenuOpen(!menuOpen)
                                                                                setRecordSharedId(data.recordShareId)
                                                                                handleOpenModal()
                                                                            }}
                                                                        >
                                                                            <img src={deleteIcon} alt=''></img>
                                                                        </button>
                                                                        <DeleteClassificationModal
                                                                            setDeleteShowModal={setShareLinkShowModal}
                                                                            showDeleteModal={showShareLinkModal}
                                                                            handleDelete={deleteChat}
                                                                            deleteLoading={isDeleting}
                                                                            headingMessage={`Delete Share link`}
                                                                            description={`Are you sure you want to delete this link ?`}
                                                                        />
                                                                    </OutsideClickHandler>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                )}
                            </>
                        </div>
                    </div>
                </div>

                {/* begin::Footer */}

                <div className='share-drawer-footer d-flex justify-content-end ' id='kt_footer'>
                    <button onClick={() => setCreateRecordDrawer(false)} className='btn btn-light flex-grow-1 flex-md-grow-0  '>
                        {formatMessage({ id: 'Cancel' })}
                    </button>
                </div>
                {/* end::Footer */}
            </div>

        </div>
    )
}
